import React, { useEffect, useRef, useState } from "react";
import { BACKEND_URL } from "@/lib/api";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2, CheckCircle2, Upload, FileText } from "lucide-react";
import { AdmForm } from "@/components/app/Admisiones";

const API = `${BACKEND_URL}/api`;

// Formulario público de nuevo ingreso (lo llenan los papás desde el link del colegio).
export default function AdmisionPublica() {
  const { slug } = useParams();
  const [school, setSchool] = useState(null);
  const [form, setForm] = useState({ student: {}, tutor: {} });
  const [done, setDone] = useState(null);
  const [files, setFiles] = useState([]);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const fileRef = useRef(null);
  useEffect(() => { axios.get(`${API}/public/admisiones/${slug}`).then(({ data }) => setSchool(data)).catch(() => setSchool(false)); }, [slug]);

  const submit = async () => {
    setErr("");
    if (!form.student?.full_name || !form.tutor?.name) { setErr("Escribe el nombre del aspirante y del tutor."); return; }
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/public/admisiones/${slug}`, form);
      if (files.length) {
        const fd = new FormData(); fd.append("key", data.key); files.forEach((f) => fd.append("files", f));
        await axios.post(`${API}/public/admisiones/${slug}/${data.id}/docs`, fd);
      }
      setDone(data);
    } catch (e) { setErr(e?.response?.data?.detail || "No se pudo enviar. Intenta de nuevo."); } finally { setBusy(false); }
  };

  if (school === null) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-navy" /></div>;
  if (school === false) return <div className="min-h-screen flex items-center justify-center text-navy">Este formulario no está disponible.</div>;
  return (
    <div className="min-h-screen bg-gradient-to-b from-navy/10 to-white py-8 px-4" data-testid="adm-public">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-6"><img src="/zavia-icon.png" alt="ZAVIA" className="w-14 h-12 object-contain mx-auto" />
          <h1 className="font-display font-extrabold text-2xl text-navy mt-2">Solicitud de nuevo ingreso</h1><p className="text-sm text-nardo-500">{school.school_name}</p></div>
        {done ? (
          <div className="bg-white rounded-2xl shadow-xl p-8 text-center" data-testid="adm-public-done">
            <CheckCircle2 className="w-14 h-14 text-emerald-500 mx-auto" />
            <h2 className="font-display font-bold text-xl text-navy mt-3">¡Solicitud enviada!</h2>
            <p className="text-sm text-nardo-600 mt-2">Tu folio es <b className="text-navy">{done.folio}</b>. El colegio revisará la información y se pondrá en contacto contigo.</p>
          </div>
        ) : (
          <div className="bg-white rounded-2xl shadow-xl p-5 sm:p-7 space-y-5">
            <AdmForm value={form} onChange={setForm} />
            <div>
              <div className="text-xs font-bold text-navy uppercase tracking-wider mb-2">Documentos (acta, CURP, boletas, comprobante…)</div>
              <button onClick={() => fileRef.current?.click()} data-testid="adm-public-files" className="w-full border-2 border-dashed border-navy/30 rounded-xl py-5 text-sm text-navy font-semibold inline-flex items-center justify-center gap-2 hover:bg-navy/5"><Upload className="w-4 h-4" /> Agregar documentos</button>
              <input ref={fileRef} type="file" multiple className="hidden" onChange={(e) => { const n = Array.from(e.target.files || []); e.target.value = ""; setFiles((f) => [...f, ...n]); }} />
              {files.length > 0 && <div className="mt-2 space-y-1">{files.map((f, i) => (
                <div key={i} className="flex items-center gap-2 text-xs text-navy"><FileText className="w-3.5 h-3.5" /> <span className="truncate flex-1">{f.name}</span><button onClick={() => setFiles((x) => x.filter((_, j) => j !== i))} className="text-red-500">Quitar</button></div>))}</div>}
            </div>
            <label className="block"><span className="text-[11px] text-nardo-500">Comentarios</span>
              <textarea value={form.comments || ""} onChange={(e) => setForm({ ...form, comments: e.target.value })} rows={3} className="w-full border border-nardo-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-navy" /></label>
            {err && <p className="text-sm text-red-600" data-testid="adm-public-error">{err}</p>}
            <button onClick={submit} disabled={busy} data-testid="adm-public-submit" className="w-full bg-navy text-white font-bold py-3 rounded-xl inline-flex items-center justify-center gap-2 disabled:opacity-50">{busy && <Loader2 className="w-4 h-4 animate-spin" />} Enviar solicitud</button>
          </div>
        )}
      </div>
    </div>
  );
}
